module.exports = {
      id: "icon-user-usage",
      viewBox: "0 0 50 50",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-user",
      toString: function () {
        return this.url;
      }
    }